<template>
  <div class="soft-table vld-parent">
    <loading :active.sync="pending" :is-full-page="false"></loading>
    <b-table
      :no-border-collapse="true"
      ref="soft-table"
      class="table-soft"
      :style="autoheight ? `min-height:${minHeight}px; height:${height}px` : ``"
      :fields="fields"
      :sticky-header="true"
      :responsive="true"
      :items="dataTable"
      :busy="false"
      filter="true"
      :filter-function="filterTable"
      :tbody-tr-class="classTbodyTr"
      @row-clicked="doClickRow"
      @row-selected="handleRowSelected"
      select-mode="range"
      selectable
      @row-contextmenu="showMenuContext"
    >
      <template v-slot:head(id) th-class="checkbox col-fix">
        <input
          @change="doCheckedAll"
          :checked="computedItems.length == countChecked"
          class="check-input"
          type="checkbox"
        />
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(id)="{ index, rowSelected }" :class="'checkbox col-fix'">
        <input
          class="check-input"
          :checked="rowSelected"
          @change="doCheckRow(index, $event)"
          type="checkbox"
          name="checkbox"
        />
      </template>
      <template v-slot:cell(dateCreated)="{ value }">
        {{ $dateTimeUnix(value) }}
      </template>
      <template v-slot:cell(dateUpdated)="{ value }">
        {{ $dateTimeUnix(value) }}
      </template>
      <template v-slot:cell(color)="{ value }">
        {{ value.label }}
      </template>
      <template v-for="slotName in Object.keys($scopedSlots)" v-slot:[slotName]="slotScope">
        <slot :name="slotName" v-bind="slotScope"></slot>
      </template>
      <template v-slot:cell(action)="{ index, item }">
        <b-button
          v-if="!permission || $permission(permission.edit)"
          @click="doEditRow(index, item)"
          variant="outline-primary px-1 py-0"
        >
          <i class="fas fa-edit    "></i>
        </b-button>
        <b-button
          v-if="!noDelete && (!permission || $permission(permission.delete))"
          @click="doDeleteRow(index, item)"
          variant="outline-danger px-1 py-0"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </b-button>
        <slot :name="'action'" v-bind="{ index, item }"></slot>
      </template>
      <template v-slot:custom-foot>
        <slot v-if="computedItems.length == 0" name="norecord">
          <b-tr>
            <b-td :colspan="fields && fields.length > 0 ? fields.length : 1">
              <span class="text-center d-block mt-3">Không có dữ liệu</span>
              <div v-if="norecordAdd" class="justify-content-md-center d-flex mb-2">
                <div style="width:150px">
                  <add-button @click="norecordAdd"></add-button>
                </div>
              </div>
            </b-td>
          </b-tr>
        </slot>
      </template>
    </b-table>
    <slot name="footer"></slot>
    <context-menu v-if="contextMenus" ref="context" :menus="contextMenus" @click="contextMenuItemClick"></context-menu>
  </div>
</template>
<script>
export default {
  name: 'soft-table',
  props: {
    dataTable: {
      type: Array,
      default: () => [],
      description: 'Table data'
    },
    fields: {
      type: Array
    },
    pending: {
      type: Boolean, // striped | hover
      default: true,
      description: 'Show / Hidden Control'
    },
    showAll: {},
    norecordAdd: {
      type: Function
    },
    minHeight: {
      type: Number, // striped | hover
      default: 150,
      description: 'Min Height Table . Unit = px'
    },
    height: {
      type: Number, // striped | hover
      default: 150,
      description: 'Height Table . Unit = px'
    },
    noDelete: {
      default: false
    },
    autoheight: {
      default: true
    },
    theadClasses: {
      type: String,
      default: '',
      description: '<thead> css classes'
    },
    tbodyClasses: {
      type: String,
      default: '',
      description: '<tbody> css classes'
    },
    contextMenus: {
      type: Array,
      default: () => [],
      description: 'menu context'
    },
    filter: {
      type: Object,
      default: () => {
        return {};
      }
    },
    permission: {
      type: Object
    }
  },
  mounted() {
    this.computedItems = this.$refs['soft-table'].computedItems;
  },
  data() {
    return {
      selectedRow: -1,
      countChecked: 0,
      computedItems: [],
      delayTimer: null
    };
  },
  updated() {
    // let tbodyTD = this.$refs["tbody-tr"][0].children;
    // let theadTD = this.$refs["thead-tr"].cells;
    // for (let i = 0; i < tbodyTD.length; i++) {
    //   theadTD[i].setAttribute("style",`width :${tbodyTD[i].clientWidth}`);
    // }
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`;
    }
  },
  methods: {
    showMenuContext(item, index, $event) {
      if (this.contextMenus.length > 0) this.$refs.context.doShow(item, $event);
    },
    contextMenuItemClick({ menu, index, data: data }) {
      this.$emit('contextMenuItemClick', { menu, index, data: data });
    },
    handleRowSelected(items) {
      this.countChecked = items.length;
      this.$emit('rowSelected', items);
    },
    refreshed() {
      this.computedItems = this.$refs['soft-table'].computedItems;
    },
    doCheckRow(index, e) {
      if (e.target.checked) {
        this.$refs['soft-table'].selectRow(index);
      } else {
        this.$refs['soft-table'].unselectRow(index);
      }
    },
    doClickRow(item, index) {
      this.$emit('rowClicked', item, index);
    },
    selectRow(index) {
      var self = this;
      setTimeout(() => {
        this.computedItems = this.$refs['soft-table'].computedItems;
        if (index < self.computedItems.length) {
          let item = self.computedItems[index];
          self.$refs['soft-table'].selectRow(index);
          self.$emit('rowClicked', item, index);
        }
      }, 0);
    },
    doCheckedAll(e) {
      // var dataTmp = this.dataTable;
      if (e.target.checked) {
        this.$refs['soft-table'].selectAllRows();
      } else {
        this.$refs['soft-table'].clearSelected();
      }
      // this.table = [];
      // this.table = dataTmp;
      // this.selectedRow = -1;
    },
    removeElementsNotIn(a, b) {
      return a.filter(function(item) {
        return b.indexOf(item) < 0; // Returns true for items not found in b.
      });
    },
    filterTable(row) {
      if (this.filter) {
        if (row[this.filter.key] == this.filter.value) {
          return true;
        } else {
          return false;
        }
      } else {
        if (row.active || this.showAll) {
          return true;
        } else {
          return false;
        }
      }
    },
    classTbodyTr(row) {
      let mclass = '';
      if (row.checked) mclass += ' checked-row';
      if (row.focus || row.isDefault) mclass += ' active';
      return mclass;
    },
    doEditRow: function(index, item) {
      this.$refs['soft-table'].clearSelected();
      this.selectRow(index);
      setTimeout(() => {
        this.$emit('doEditRow', index, item);
      }, 10);
    },
    doDeleteRow: function(index, item) {
      this.$refs['soft-table'].clearSelected();
      this.selectRow(index);
      var self = this;
      setTimeout(() => {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            self.$emit('doDeleteRow', index, item);
          }
        });
      }, 10);
    }
  },
  watch: {
    dataTable: function() {
      setTimeout(() => {
        this.computedItems = this.$refs['soft-table'].computedItems;
      }, 1);
    }
  }
};
</script>

<style lang="scss">
.soft-table {
  border: 2px solid #ccebf8;
  table {
    tbody {
      tr {
        &:focus {
          background: #cddff1 !important;
        }
      }
    }
  }
}
</style>
